import PopUpAd from "./PopUpAd";

const { register } = require("@lpm/pug-components/dist/register");

register("PopUpAd/PopUpAd", PopUpAd);
